/* ZilZal global transitions (by Claude)
   Card press-in feedback on click -> product page. Navigation is NOT delayed:
   the old version cancelled the click and navigated 230 ms later for a fade
   overlay that no stylesheet ever styled, so every product click was simply
   230 ms slower. Loading feedback now comes from snippets/zz-loading.liquid.
   Defers to the theme's native product image morph (product-card-link) when enabled. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', function (e) {
    if (reduced.matches) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href*="/products/"]');
    if (!a) return;
    if (a.target && a.target !== '_self') return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return;
    if (a.closest('product-card-link')) return; /* native view-transition morph handles this click */

    var card = a.closest('.bxc-card, product-card, .resource-card');
    if (card) card.classList.add('is-leaving');
  });

  /* Back/forward cache: never restore a card stuck mid-press */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.is-leaving').forEach(function (el) { el.classList.remove('is-leaving'); });
  });
})();

/* ZilZal cart trigger (by Claude). DESKTOP (>=750px): render the cart trigger as a vertical side TAB pinned to the LEFT edge, and open the drawer from the LEFT to match the RTL layout. Mobile/tablet keep their existing bottom pill. The fly-to-cart image animation that used to run on every [data-bxp-add]/[data-bxc-add] click (product pages, collection/related cards) has been removed -- it was a second, site-wide instance of the same lag the hero carousel's own fly animation caused, and this one fired far more often. */
(function () {
  var css = '@media (min-width:750px){'
    + '#zzfc-root{left:0 !important;right:auto !important;top:50% !important;bottom:auto !important;transform:translateY(-50%) !important;}'
    + '#zzfc-root[data-empty=true],#zzfc-root.zzcart-open{transform:translateY(-50%) translateX(-100%) !important;opacity:0 !important;visibility:hidden !important;pointer-events:none !important;}'
    + '#zzfc{flex-direction:column !important;gap:9px !important;padding:15px 10px !important;border-radius:0 16px 16px 0 !important;}'
    + '#zzfc .zzfc__icon svg{width:24px !important;height:24px !important;}'
    + '#zzfc .zzfc__text{writing-mode:vertical-rl !important;text-orientation:mixed !important;font-size:13px !important;font-weight:800 !important;letter-spacing:1px !important;}'
    + '#zzfc .zzfc__total{display:none !important;}'
    + '#zzcart{left:0 !important;right:auto !important;transform:translateX(-100%) !important;border-inline-start:0 !important;border-inline-end:1px solid rgba(107,76,255,.3) !important;box-shadow:26px 0 70px rgba(0,0,0,.6) !important;}'
    + '#zzcart.is-open{transform:translateX(0) !important;}'
    + '}';
  var st = document.createElement('style');
  st.setAttribute('data-zzfc-desktop', '1');
  st.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(st);
})();

/* ZilZal instant cart count (by Claude). The floating pill previously only moved
   once /cart.js came back. This bumps the pill's count badge on the same frame as
   the click; zz-floating-cart's commit() then repaints that badge from the real
   cart on every cart request, so a bumped number is always overwritten by server
   truth rather than persisting.
   The add delta is computed, not guessed: bxc-minqty.js clamps an add up to a
   per-variant minimum (exposed as window.__zzMinForKey) and doubles BOGO
   variants, which bxc-card.liquid marks with .bxc-card__bogo.
   Stepper +/- move the badge by one. That is deliberately approximate for
   min-order lines, where the last minus removes the whole line rather than one
   unit; the next server response corrects it. Being briefly off by a few beats
   showing nothing at all while several writes drain from the queue below.
   Capture phase, so it runs before the section handlers that swap the button for
   the stepper and detach it from its card. */
(function () {
  function badge() {
    var root = document.getElementById('zzfc-root');
    var el = root && root.querySelector('[data-zzfc-count]');
    return el ? { root: root, el: el } : null;
  }
  function nudge(delta) {
    var b = badge();
    if (!b) return;
    var next = (parseInt(b.el.textContent, 10) || 0) + delta;
    if (next < 0) next = 0;
    b.el.textContent = next;
    b.root.setAttribute('data-empty', next > 0 ? 'false' : 'true');
  }
  function addedQty(vid, card) {
    var min = 0;
    try { min = (window.__zzMinForKey && window.__zzMinForKey(String(vid))) || 0; } catch (e) { min = 0; }
    var q = min > 1 ? min : 1;
    if (card && card.querySelector('.bxc-card__bogo')) q = q * 2;
    return q;
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var btn = e.target.closest('[data-bxc-add]');
    if (btn && !btn.disabled && !btn.classList.contains('is-disabled')) {
      var vid = btn.getAttribute('data-vid');
      var card = btn.closest('.bxc-card');
      if (vid && card) nudge(addedQty(vid, card));
      return;
    }
    if (e.target.closest('[data-bxc-plus]')) { nudge(1); return; }
    if (e.target.closest('[data-bxc-minus]')) { nudge(-1); return; }
  }, true);
})();

/* ZilZal cart write queue + broadcast (by Claude).

   TWO jobs, deliberately in one wrapper because the second depends on the first.

   1) SERIALIZE. Every cart write used to go out the moment it was clicked.
      Adding several products quickly fired that many concurrent POSTs, and the
      Cart API serializes them behind a per-session lock anyway, so they came
      back out of order. Each response is a FULL cart snapshot from its own
      moment, and collection-shelves' bxcApplyCart repaints every card from
      whichever snapshot arrives -- including tearing a stepper back down to an
      Add button when the snapshot predates that line. Seven fast adds therefore
      showed three or four. Queuing the writes here means a response can never
      describe an older cart than one already applied, which fixes the cards,
      the drawer and the pill count at once without any of them knowing.
      Reads (/cart.js) are NOT queued -- they never mutate and must stay cheap.

   2) BROADCAST. Any mutation whose response carries a full cart is re-dispatched
      as a `zz:cart` event with that cart attached, so UI that did not make the
      request can reconcile without firing one of its own. Purely an observer:
      the request and its response pass through untouched.

   Note on ordering with bxc-minqty.js: theme.liquid loads this file first, so
   minqty's wrapper ends up OUTSIDE this one. Quantities are therefore clamped
   before they reach the queue, which is the order we want. */
(function () {
  if (!window.fetch) return;
  var rxWrite = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var inner = window.fetch;
  var chain = Promise.resolve();

  function broadcast(res) {
    if (!res || !res.ok) return res;
    try {
      res.clone().json().then(function (cart) {
        if (cart && typeof cart.item_count !== 'undefined') {
          document.dispatchEvent(new CustomEvent('zz:cart', { detail: cart }));
        }
      }).catch(function () {});
    } catch (e) {}
    return res;
  }

  window.fetch = function () {
    var self = this;
    var args = arguments;
    var url = '';
    try { url = (args[0] && args[0].url) ? args[0].url : ('' + args[0]); } catch (e) {}
    if (!rxWrite.test(url)) return inner.apply(self, args);

    function run() { return inner.apply(self, args).then(broadcast); }
    /* Run whether the previous write resolved or rejected -- one failure must not
       strand every later write in the queue. */
    var result = chain.then(run, run);
    chain = result.then(function () {}, function () {});
    return result;
  };
})();

/* ZilZal account link redirect (by Claude). The sidebar's الحساب button and the
   footer account link still point at bare /account, which is Shopify's hosted
   customer-accounts page -- the one that cannot be themed. Every such link is
   repointed at our own hub, which handles both signed-in and signed-out states
   itself, so this is correct regardless of session.
   Matches ONLY a bare /account (optionally locale-prefixed, e.g. /ar/account).
   Sub-paths are deliberately left alone -- /account/logout in particular must
   keep working, and rewriting it would break signing out.
   Patched from here rather than in sections/zz-menu.liquid so one rule covers
   every occurrence sitewide, including links injected by apps. */
(function () {
  var rxAccount = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/account\/?$/i;
  var TARGET = '/pages/my-account';

  function isBareAccount(a) {
    var path;
    try { path = new URL(a.href, window.location.origin).pathname; } catch (e) { return false; }
    return rxAccount.test(path);
  }

  /* Rewrite up front so the status bar, middle-click and "open in new tab" all
     get the right destination, not just a left click. */
  function rewrite() {
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="/account"]'), function (a) {
      if (isBareAccount(a)) a.setAttribute('href', TARGET);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rewrite);
  else rewrite();
  document.addEventListener('shopify:section:load', rewrite);

  /* Capture-phase safety net for links added after the pass above ran. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a || !isBareAccount(a)) return;
    e.preventDefault();
    window.location.href = TARGET;
  }, true);
})();
